/**
 * @generated SignedSource<<0736cbde542b62af5aa45de304aedc81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZnglyContext_Backend_Query$variables = Record<PropertyKey, never>;
export type ZnglyContext_Backend_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SiteSettings_Fragment" | "Users_Fragment" | "ZnglyInfo_Settings_Fragment" | "ZnglyVideos_Pagination_Fragment">;
};
export type ZnglyContext_Backend_Query = {
  response: ZnglyContext_Backend_Query$data;
  variables: ZnglyContext_Backend_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "authorIn": null,
      "dateQuery": null,
      "mediaName": null,
      "orderby": null,
      "search": null,
      "stati": [
        "PENDING",
        "PUBLISH",
        "HIDDEN",
        "HIDDEN_B_S",
        "DRAFT"
      ]
    }
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  (v2/*: any*/),
  (v7/*: any*/),
  (v6/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Form",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "content",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitSuccessText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingConsent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v12 = [
  (v6/*: any*/),
  (v2/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v18 = [
  (v13/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "classes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "conditions",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "style",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaItem",
    "kind": "LinkedField",
    "name": "mediaItem",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v6/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = [
  (v4/*: any*/),
  (v2/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  (v6/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyContext_Backend_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Users_Fragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ZnglyInfo_Settings_Fragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SiteSettings_Fragment"
      },
      {
        "args": (v0/*: any*/),
        "kind": "FragmentSpread",
        "name": "ZnglyVideos_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZnglyContext_Backend_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToUserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToUserConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": "users(first:100)"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "id",
            "value": "site-info"
          },
          {
            "kind": "Literal",
            "name": "idType",
            "value": "SLUG"
          }
        ],
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo_Znglyinfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceMid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "leadfeederTracker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoomInfoTracker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotAgentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotDatastoreId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleAnalyticsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "umamiAnalyticsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dashboardLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacyPolicy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacyPolicyTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacyPolicyEditing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacyPolicyDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacyUserConsentLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "browserTabTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "favicon",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "homePreviewImage",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "homePreviewDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontStyle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "qrPrimaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "qrSecondaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "qrImage",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backendPrimaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backendSecondaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_pvImages",
                "kind": "LinkedField",
                "name": "pvImages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaItem",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "headerLogo",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerTextConditions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerLogoLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerSecondaryAccentClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerPrimaryAccentClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerBgClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userMenuBackgroundClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userMenuLinkClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userMenuLinkHoverClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_headerButtons",
                "kind": "LinkedField",
                "name": "headerButtons",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bgColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bgHvColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textHvColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ZnglyInfo_Znglyinfo_headerButtonsToFormConnectionEdge",
                    "kind": "LinkedField",
                    "name": "form",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_customSocialLinks",
                "kind": "LinkedField",
                "name": "customSocialLinks",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bodyDescBoxClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bodyDescBoxTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readMorePrimaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readMoreSecondaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readMorePrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaPrimaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaSecondaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pagePrimaryAccClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pagePrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageSecondaryAccClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareBtnPrimaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shareBtnSecondaryClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "catZnglistClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ddBgClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ddPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ddSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchPlaceholder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "searchPlaceholderAi",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "searchImage",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "searchImageAi",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linksTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_links",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address3",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerAccentClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerBgClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerPrimaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerSecondaryTxtClr",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_Pinning",
                "kind": "LinkedField",
                "name": "pinning",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pinContentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedList",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "Znglist",
                        "abstractKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedVideo",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "ZnglyVideo",
                        "abstractKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotPrimaryColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotFontFamily",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotFontColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotBubbleBackground",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotTitlebarBackground",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotTitlebarFontColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotChatBackground",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotBorderRadius",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatbotSendIconColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteSettings",
        "kind": "LinkedField",
        "name": "siteSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagFunctionalityType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagStaticList",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteSettingsUiMetaField",
            "kind": "LinkedField",
            "name": "hdLogoText",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteSettingsUiMetaField",
            "kind": "LinkedField",
            "name": "hdLogo",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "RootQueryToZnglyVideoConnection",
        "kind": "LinkedField",
        "name": "znglyVideos",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToZnglyVideoConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyVideo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "databaseId",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trashDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trashTimeUntil",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NodeWithAuthorToUserConnectionEdge",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "slug",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v1/*: any*/),
                    "concreteType": "ZnglyVideoToCategoryConnection",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyVideoToCategoryConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "categories(first:100)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusSettings",
                    "kind": "LinkedField",
                    "name": "statusSettings",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StateWhenApproved",
                        "kind": "LinkedField",
                        "name": "stateWhenApproved",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ApprovedState",
                        "kind": "LinkedField",
                        "name": "approved",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ZnglyVideo_Znglycontent",
                    "kind": "LinkedField",
                    "name": "znglyContent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aiSummary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentEmbedHtml",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentMediaName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentMediaType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "contentFile",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaItem",
                        "kind": "LinkedField",
                        "name": "featuredImageFile",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featuredImageLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
                        "kind": "LinkedField",
                        "name": "form",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "htmlDesc",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortText",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToZnglyVideoConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": "znglyVideos(first:24,where:{\"authorIn\":null,\"dateQuery\":null,\"mediaName\":null,\"orderby\":null,\"search\":null,\"stati\":[\"PENDING\",\"PUBLISH\",\"HIDDEN\",\"HIDDEN_B_S\",\"DRAFT\"]})"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "ZnglyVideos_Pagination_Fragment_Connection_znglyVideos",
        "kind": "LinkedHandle",
        "name": "znglyVideos"
      }
    ]
  },
  "params": {
    "cacheID": "0b745313720297037244468bd32fe7ba",
    "id": null,
    "metadata": {},
    "name": "ZnglyContext_Backend_Query",
    "operationKind": "query",
    "text": "query ZnglyContext_Backend_Query {\n  ...Users_Fragment\n  ...ZnglyInfo_Settings_Fragment\n  ...SiteSettings_Fragment\n  ...ZnglyVideos_Pagination_Fragment_4dYVV8\n}\n\nfragment SiteSettings_Fragment on RootQuery {\n  siteSettings {\n    id\n    tagFunctionalityType\n    tagStaticList\n    hdLogoText {\n      __typename\n      id\n      value\n      classes\n      conditions\n      style\n      mediaItem {\n        id\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        description\n      }\n    }\n    hdLogo {\n      __typename\n      id\n      value\n      classes\n      conditions\n      style\n      mediaItem {\n        id\n        mediaItemUrl\n        mediaDetails {\n          sizes {\n            sourceUrl\n            name\n          }\n        }\n        description\n      }\n    }\n  }\n}\n\nfragment Users_Fragment on RootQuery {\n  users(first: 100) {\n    edges {\n      node {\n        id\n        username\n        name\n        role\n      }\n    }\n  }\n}\n\nfragment ZnglyInfo_Settings_Fragment on RootQuery {\n  znglyInfo(id: \"site-info\", idType: SLUG) {\n    id\n    znglyInfo {\n      ...integrations_Settings_Fragment\n      ...analytics_Settings_Fragment\n      ...privacyPolicy_Settings_Fragment\n      ...siteSettings_Settings_Fragment\n      ...globalStyles_Settings_Fragment\n      ...qrCodeTab_Settings_Fragment\n      ...backend_Settings_Fragment\n      ...personalisedVideo_Settings_Fragment\n      ...header_Settings_Fragment\n      ...body_Settings_Fragment\n      ...footer_Settings_Fragment\n      ...homePage_Settings_Fragment\n      ...chatbot_Settings_Fragment\n    }\n  }\n}\n\nfragment ZnglyVideos_Pagination_Fragment_4dYVV8 on RootQuery {\n  znglyVideos(first: 24, where: {search: null, orderby: null, mediaName: null, stati: [PENDING, PUBLISH, HIDDEN, HIDDEN_B_S, DRAFT], authorIn: null, dateQuery: null}) {\n    edges {\n      node {\n        id\n        databaseId\n        title\n        link\n        date\n        status\n        trashDate\n        trashTimeUntil\n        author {\n          node {\n            id\n            name\n            username\n            slug\n          }\n        }\n        categories(first: 100) {\n          edges {\n            node {\n              name\n              id\n            }\n          }\n        }\n        statusSettings {\n          status\n          uiPermission {\n            type\n          }\n          stateWhenApproved {\n            status\n            uiPermission {\n              type\n            }\n          }\n          approved {\n            id\n            timestamp\n            user {\n              name\n              id\n            }\n          }\n        }\n        znglyContent {\n          aiSummary\n          contentEmbedHtml\n          contentMediaName\n          contentMediaType\n          contentLink\n          contentFile {\n            mediaItemUrl\n            mediaDetails {\n              sizes {\n                sourceUrl\n                name\n              }\n            }\n            description\n            id\n          }\n          featuredImageFile {\n            mediaItemUrl\n            mediaDetails {\n              sizes {\n                sourceUrl\n                name\n              }\n            }\n            description\n            id\n          }\n          featuredImageLink\n          ctaLink\n          ctaName\n          form {\n            node {\n              id\n              title\n              content\n              schema\n              uiSchema\n              metadata {\n                formStyle\n                formTemplate\n                cookieExpiration\n                submitSuccessText\n              }\n              marketingConsent\n              password\n              imageUrl\n            }\n          }\n          htmlDesc\n          shortText\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment analytics_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  googleAnalyticsId\n  umamiAnalyticsId\n  dashboardLink\n}\n\nfragment backend_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  backendPrimaryColor\n  backendSecondaryColor\n}\n\nfragment body_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  bodyDescBoxClr\n  bodyDescBoxTxtClr\n  readMorePrimaryClr\n  readMoreSecondaryClr\n  readMorePrimaryTxtClr\n  ctaPrimaryClr\n  ctaSecondaryClr\n  ctaPrimaryTxtClr\n  pagePrimaryAccClr\n  pagePrimaryTxtClr\n  pageSecondaryAccClr\n  pageSecondaryTxtClr\n  shareBtnPrimaryClr\n  shareBtnSecondaryClr\n  catZnglistClr\n  ddBgClr\n  ddPrimaryTxtClr\n  ddSecondaryTxtClr\n  searchPlaceholder\n  searchPlaceholderAi\n  searchImage {\n    mediaItemUrl\n    id\n  }\n  searchImageAi {\n    mediaItemUrl\n    id\n  }\n}\n\nfragment chatbot_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  chatbotTitle\n  chatbotPrimaryColor\n  chatbotFontFamily\n  chatbotFontColor\n  chatbotBubbleBackground\n  chatbotTitlebarBackground\n  chatbotTitlebarFontColor\n  chatbotChatBackground\n  chatbotBorderRadius\n  chatbotSendIconColor\n}\n\nfragment footer_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  linksTitle\n  links {\n    linkName\n    linkUrl\n  }\n  address1\n  address2\n  address3\n  email\n  phone1\n  phone2\n  footerAccentClr\n  footerBgClr\n  footerPrimaryTxtClr\n  footerSecondaryTxtClr\n}\n\nfragment globalStyles_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  fontStyle\n}\n\nfragment header_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  headerLogo {\n    id\n    title\n    mediaItemUrl\n  }\n  headerText\n  headerTextConditions\n  headerLogoLink\n  headerSecondaryTxtClr\n  headerSecondaryAccentClr\n  headerPrimaryTxtClr\n  headerPrimaryAccentClr\n  headerBgClr\n  userMenuBackgroundClr\n  userMenuLinkClr\n  userMenuLinkHoverClr\n  headerButtons {\n    name\n    url\n    bgColor\n    textColor\n    bgHvColor\n    textHvColor\n    formId\n    form {\n      node {\n        id\n        title\n        content\n        schema\n        uiSchema\n        metadata {\n          formStyle\n          formTemplate\n          cookieExpiration\n          submitSuccessText\n        }\n        marketingConsent\n        password\n        imageUrl\n      }\n    }\n  }\n  customSocialLinks {\n    name\n    url\n  }\n}\n\nfragment homePage_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  pinning {\n    pinContentType\n    pinnedList {\n      __typename\n      ... on Znglist {\n        id\n        title\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    pinnedVideo {\n      __typename\n      ... on ZnglyVideo {\n        id\n        title\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment integrations_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  salesforceMid\n  leadfeederTracker\n  zoomInfoTracker\n  chatbotAgentId\n  chatbotDatastoreId\n  chatbotTitle\n}\n\nfragment personalisedVideo_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  pvImages {\n    image {\n      id\n      title\n      mediaItemUrl\n    }\n  }\n}\n\nfragment privacyPolicy_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  privacyPolicy\n  privacyPolicyTitle\n  privacyPolicyEditing\n  privacyPolicyDate\n  privacyUserConsentLevel\n}\n\nfragment qrCodeTab_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  qrPrimaryColor\n  qrSecondaryColor\n  qrImage {\n    id\n    title\n    mediaItemUrl\n  }\n}\n\nfragment siteSettings_Settings_Fragment on ZnglyInfo_Znglyinfo {\n  browserTabTitle\n  favicon {\n    id\n    mediaItemUrl\n    title\n  }\n  homePreviewImage {\n    id\n    mediaItemUrl\n    title\n  }\n  homePreviewDescription\n}\n"
  }
};
})();

(node as any).hash = "e52b7bdccc9b12ef0dc7c7fc64dbd35f";

export default node;
